import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CompanyProvisionRepository } from '@app/domain/ports/tpv/company-provision.repository';
import {
  CompanyProvisionResult,
  CompanyStandaloneResult,
} from '@app/domain/models/tpv/company.model';
import {
  CompanyProvisionResponseDto,
  CompanyStandaloneResponseDto,
  ProvisionCompanyRequest,
  ProvisionCompanyStandaloneRequest,
} from '@app/data/dtos/tpv/company-provision.dto';
import {
  mapCompanyProvisionResult,
  mapCompanyStandaloneResult,
} from '@app/data/mappers/tpv/company-provision.mapper';
import { tpvUrl } from '@app/data/tpv/tpv-api.config';
import { TpvEnvelope, unwrapTpv } from '@app/data/tpv/tpv-envelope';

/**
 * Provisión de Company en TPV (IsAdmin). Auth vía interceptores estándar
 * (sesión de banca); solo el alta standalone añade `Idempotency-Key` (obligatoria).
 */
@Injectable()
export class CompanyProvisionRemoteDataSource extends CompanyProvisionRepository {
  private readonly http = inject(HttpClient);

  override provisionCompany(
    idCompany: string,
    request: ProvisionCompanyRequest,
  ): Observable<CompanyProvisionResult> {
    return this.http
      .post<TpvEnvelope<CompanyProvisionResponseDto> | CompanyProvisionResponseDto>(
        tpvUrl(`companies/${idCompany}/provision/`),
        request,
      )
      .pipe(map((resp) => mapCompanyProvisionResult(unwrapTpv(resp), idCompany)));
  }

  /** `POST /api/v1/tpv/companies/provision-standalone/` (IsAdmin, Idempotency-Key obligatoria). */
  override provisionStandalone(
    request: ProvisionCompanyStandaloneRequest,
    idempotencyKey: string,
  ): Observable<CompanyStandaloneResult> {
    return this.http
      .post<TpvEnvelope<CompanyStandaloneResponseDto> | CompanyStandaloneResponseDto>(
        tpvUrl('companies/provision-standalone/'),
        request,
        {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Idempotency-Key': idempotencyKey,
          }),
        },
      )
      .pipe(map((resp) => mapCompanyStandaloneResult(unwrapTpv(resp))));
  }
}
